import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
interface Tab {
  id: string;
  label: string;
}
interface SimulatorTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}
export const SimulatorTabs = ({
  tabs,
  activeTab,
  onTabChange
}: SimulatorTabsProps) => {
  return <div className="border-b border-gray-200" data-id="element-1124">
      <nav className="flex overflow-x-auto" aria-label="Tabs" data-id="element-1125">
        {tabs.map(tab => <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`
              relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-center text-sm font-medium focus:z-10
              ${activeTab === tab.id ? 'border-b-2 border-blue-500 text-blue-600' : 'border-b-2 border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}
            `} data-id="element-1126">
            <span data-id="element-1127">{tab.label}</span>
            {tab.id === 'general' && <CheckCircleIcon className="h-4 w-4 text-green-500 absolute right-4 top-1/2 transform -translate-y-1/2" data-id="element-1128" />}
          </button>)}
      </nav>
    </div>;
};